module.exports = __webpack_public_path__ + "static/media/default-image.62461204.svg";